import React, {Component, PropTypes} from 'react';
import classNames from 'classnames';
import ga from 'react-ga';
import {translate as t} from 'lang';
import {CargoType} from 'types';
import GeneralStore from 'stores/GeneralStore';
import CategoryStore from 'stores/CategoryStore';
import CargosStore from 'stores/CargosStore';
import EditingCargoStore from 'stores/EditingCargoStore';
import ActionCreators from 'actions/ActionCreators';
import SubcategoriesConstants from 'constants/Subcategories';
import DeliveryCargos from './DeliveryCargos.js';
import Subcategories from './Subcategories.js';
import ButtonControl from 'components/ButtonControl';
import IconControl from 'components/IconControl';
import SelectedCategory from 'components/SelectedCategory';
import MobileBackButton from 'components/MobileBackButton';
import ProgressBarPane from 'components/ProgressBarPane';
import Notice from 'components/NoticeControl';
import CargosConstants from 'constants/Cargos'
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { withRouter } from 'react-router'

import './MovingScreen.scss';

function getStateFromStores() {
    return {
        selectedCategory: CategoryStore.getSelected(),
        allCargos: CargosStore.getAllCargos(),
        cargos: CargosStore.getDeliveryCargos(),
        isCargoTypesShown: CargosStore.isCargoTypesShown(),
        defaultCargo: CargosStore.getCargoByStuffTypeId(SubcategoriesConstants.MOVING_ID),
        isEditMode: GeneralStore.isEditMode(),
    }
}

class MovingScreen extends Component {
    
    static propTypes = {
        cargos: PropTypes.objectOf(CargoType),
    }
    
    constructor(props) {
        super(props)
        const state = getStateFromStores()
        
        this.state = {
            ...state,
            movingQueryType: this.props.location.query.moving_type,
        }
    }
    
    shouldComponentUpdate() {
        if (EditingCargoStore.isEditing()) {
            return false;
        }
        
        return PureRenderMixin.shouldComponentUpdate.call(this);
    }
    
    componentDidMount() {
        CategoryStore.addChangeListener(this._onChange);
        CargosStore.addChangeListener(this._onChange);
    
        this.props.router.setRouteLeaveHook(this.props.route, (nextLocation) => {
            if (this.state.cargos && this.state.cargos.size > 0 && nextLocation && nextLocation.pathname === '/') {
                return t('WARNING_RETURN_TO_CATEGORY_SELECTION')
            }
        })
    }
    
    componentWillUnmount() {
        CategoryStore.removeChangeListener(this._onChange);
        CargosStore.removeChangeListener(this._onChange);
    }
    
    _onChange = () => {
        this.setState(getStateFromStores());
    }
    
    _onCargoFinish = () => {
        ActionCreators.cancelTankmenValidation();
        ActionCreators.cargoComplete(this.state.selectedCategory.name, this.props.location.query);
        
        ga.event({
            category: 'orders',
            action: 'add_orders_new_s2',
            label: this.state.selectedCategory.name,
        });
    }
    
    _onBackClick = () => {
        ga.event({
            category: 'buttons',
            action: 'click_button_booking_step_2',
            label: 'return_s1',
            value: 1,
        })
    
        ActionCreators.setStage('/', this.props.location.query)
    }
    
    transitionToAllCargos = () => {
        //if (this.state.cargos.size == 0) return;
        //history.pushState(null, `/category/moving/cargos`);
    }
    
    _clickMobileBackButton = (stage) => {
        ga.event({
            category: 'buttons',
            action: 'click_button_booking_step_2',
            label: 'return_s1',
            value: 1,
        })
    
        ActionCreators.setStage('/', this.props.location.query)
    }
    
    _onEditComplete = () => {
        if (confirm(t('EDIT_ORDER_WARNING'))) {
            ActionCreators.showLoadingOverlay();
            ActionCreators.cancelTankmenValidation();
            
            ActionCreators.submitUpdate()
            .catch(error => {
                ActionCreators.hideLoadingOverlay();
                if (typeof error === 'string') {
                    alert(t(error));
                }
            });
        }
    }
    
    render() {
        const {cargos, selectedCategory, allCargos} = this.state
        
        const textAboveButtons = classNames([
            'MovingScreen-description',
            {
                '-active': cargos.size > 0,
            },
        ])
        
        const delivery = (
            <DeliveryCargos
                onEditCargo={this.handlerEditCargo}
                onRemoveCargo={this.handlerRemoveCargoByIndex}
            />
        )
        
        return (
            <div className="MovingScreen container">
                <div className="MovingScreen-MobileBackButton">
                    <span className="MovingScreen-MobileBackButtonLabel">Выбранная категория</span>
                    {!this.state.isEditMode ?
                        <MobileBackButton label={selectedCategory.get('title')}
                                          address={'/'}
                                          onClick={this._clickMobileBackButton}/> :
                        <div className="MovingScreen-MobileTitle">{selectedCategory.get('title')}</div>}
                </div>
                <div className="MovingScreen-header">
                    <div className="MovingScreen-selectedCategory">
                        <SelectedCategory category={selectedCategory}/>
                    </div>
                    <div className="MovingScreen-notice">
                        <Notice type="info">{t('MOVING_INFO_NOTICE')}</Notice>
                    </div>
                    <div className="clearfix"></div>
                </div>
                {delivery}
                <Subcategories
                    cargos={allCargos}
                    onAddCargo={this.handlerAddCargo}
                    onAddNewCargo={this.handlerAddNewCargo}
                    onRemoveCargo={this.handlerRemoveCargoById}
                    toAllCargos={this.transitionToAllCargos}
                    movingQueryType={this.state.movingQueryType}/>
                
                <div className={textAboveButtons}>
                    Если вы закончили добавление грузов, переходите на следующий шаг.
                </div>
                
                <div className="MovingScreen-buttons">
                    {this.state.isEditMode ?
                        <ButtonControl
                            className="MovingScreen-submitUpdate"
                            view="forest"
                            size="s"
                            onClick={this._onEditComplete}>
                            {t('SAVE')}
                        </ButtonControl> :
                        <ButtonControl className="MovingScreen-back"
                                       view="stone"
                                       size="s"
                                       leftIcon={<IconControl name="leftArrow"/>}
                                       onClick={this._onBackClick}>
                            {t('BACK')}
                        </ButtonControl>
                    }
                    <ButtonControl className="MovingScreen-next"
                                   id="next_step"
                                   view="sand"
                                   shadow={false}
                                   size="m"
                                   disabled={cargos.size === 0}
                                   rightIcon={<IconControl name="rightArrow"/>}
                                   onClick={this._onCargoFinish}>
                        {t('NEXT_STEP')}
                    </ButtonControl>
                </div>
                <ProgressBarPane locations={this.props.location}/>
            </div>
        )
    }
    
    handlerAddCargo = (cargoId, stuffTypeId, name, attributes = []) => {
        // Not consistent data from server
        attributes = attributes.map(attribute => {
            if (attribute.name === 'unit_of_measurement' && attribute.value === undefined) {
                return {
                    ...attribute,
                    value: [CargosConstants.UNITS.CM],
                }
            }
            
            return attribute
        })
        
        var cargo = CargosStore.getCargo(cargoId, stuffTypeId)
        if (!cargo) {
            cargo = {
                id: cargoId,
                stuff_type_id: stuffTypeId,
                name: name,
                attributes: attributes,
            }
        }
        
        if (CargosStore.isSubcategory(cargo)) return;
        
        var cargoType = CargosStore.createCargoType(cargo);
        
        if (cargoType.attributes.has('quantity')) {
            var quantity = cargoType.attributes.get('quantity').set('value', 1);
            cargoType = cargoType.setIn(['attributes', 'quantity'], quantity)
        }
        
        if (cargoType.attributes.has('name')) {
            var name = cargoType.attributes.get('name').set('value', cargo.name);
            cargoType = cargoType.setIn(['attributes', 'name'], name);
        }
        
        if (cargoType.getIn(['attributes', 'length', 'value']) ||
            cargoType.getIn(['attributes', 'height', 'value']) ||
            cargoType.getIn(['attributes', 'width', 'value']) ||
            cargoType.getIn(['attributes', 'weight', 'value']) ||
            cargoType.getIn(['attributes', 'volume', 'value'])) {
            cargoType = cargoType.set('show_approximate_units_warning', true);
        }
        
        if (cargoType.attributes.has('weight') || cargoType.attributes.has('volume')) {
            let weight = cargoType.getIn(['attributes', 'weight', 'value']) || 0;
            let volume = cargoType.getIn(['attributes', 'volume', 'value']) || 0;
            
            volume /= 1000000; // => m3
            
            weight = Math.round(weight * 100) / 100; // toFixed(2 or less)
            volume = Math.round(volume * 100) / 100; // toFixed(2 or less)
            
            const totalWeight = weight + CargosStore.getTotalMeasurements().get('total_weight');
            const totalVolume = volume + CargosStore.getTotalMeasurements().get('total_volume');
            
            ActionCreators.setTotalMeasurements(totalWeight, totalVolume);
        }
        
        ActionCreators.addCargoToDelivery(cargoType);
    }
    
    handlerRemoveCargoByIndex = (index) => {
        const confirmCallback = (confirm) => {
            if (confirm) {
                const cargoId = CargosStore.getDeliveryCargoByIndex(index).toJS().id;
                
                this.updateTotalMeasurements(cargoId);
                ActionCreators.removeCargo(index);
            }
        }
        
        confirmCallback(confirm(t('REALLY_WANT_TO_REMOVE_CARGO')));
    }
    
    handlerRemoveCargoById = (event, id) => {
        const confirmCallback = (confirm) => {
            if (confirm) {
                this.updateTotalMeasurements(id);
                ActionCreators.removeCargoFromDelivery(id);
            } else {
                event.preventDefault() // don`t disable checkbox
            }
        };
        
        confirmCallback(confirm(t('REALLY_WANT_TO_REMOVE_CARGO')))
    }
    
    handlerEditCargo(cargo, cargoId) {
        ActionCreators.startCargoEditing(cargo, cargoId);
    }
    
    handlerAddNewCargo(cargo) {
        ActionCreators.addCargo(cargo);
    }
    
    updateTotalMeasurements = (cargoId) => {
        let cargo = {};
        
        this.state.cargos.forEach(item => {
            if (item.id === cargoId) {
                cargo = item.toJS();
            }
        });
        
        if (cargo.attributes.weight || cargo.attributes.volume) {
            let weight = cargo.attributes.weight.value || 0;
            let volume = cargo.attributes.volume.value || 0;
            const count = cargo.attributes.quantity.value;
            
            volume /= 1000000; // => m3
            
            weight = Math.round(weight * 100) / 100; // toFixed(2 or less)
            volume = Math.round(volume * 100) / 100; // toFixed(2 or less)
            
            let totalWeight = CargosStore.getTotalMeasurements().get('total_weight') - weight * count;
            let totalVolume = CargosStore.getTotalMeasurements().get('total_volume') - volume * count;
            
            if (totalWeight < 0 || this.state.cargos.size === 1) totalWeight = 0;
            if (totalVolume < 0 || this.state.cargos.size === 1) totalVolume = 0;
            
            ActionCreators.setTotalMeasurements(totalWeight, totalVolume);
        }
    }
}

export default withRouter(MovingScreen);



// WEBPACK FOOTER //
// ./client/components/Categories/Moving/MovingScreen.js